import React, { useEffect, useState } from 'react';
import { FaChevronDown, FaEdit, FaChevronUp, FaTimes, FaChartLine, FaTachometerAlt, FaUsers, FaDollarSign } from 'react-icons/fa';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import useUserStore from '../store';
import { fetchIntegrations } from '../Utils/apiUtils';
import IntroJs from 'intro.js';
import 'intro.js/introjs.css';
import '../App.css';
import { loadStripe } from '@stripe/stripe-js';
import { FaGhost,FaStar, FaSave, FaPlusCircle, FaCommentDots, FaLightbulb, FaBug, FaQuestionCircle, FaSpinner, FaInfoCircle, FaTrash, FaCheckCircle, FaWordpress, FaLink, FaPlus, FaMinus  } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { Modal, Textarea } from 'flowbite-react'; // Import Flowbite Modal
import { Dropdown } from 'flowbite-react';
import { FaEllipsisV } from 'react-icons/fa';
import { Button, TextInput } from 'flowbite-react';
import { PlusCircle, Search } from "lucide-react"

const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_PROMISE}`);  // Replace with your actual publishable key


const Settings = () => {
  const [openAccordion, setOpenAccordion] = useState(null);
  const [ghostApiKey, setGhostApiKey] = useState('');
  const [adminApiKey, setAdminApiKey] = useState('');
  const [ghostUrl, setGhostUrl] = useState('');
  const [wordpressUsername, setWordpressUsername] = useState('');
  const [wordpressPassword, setWordpressPassword] = useState('');
  const [wordpressUrl, setWordpressUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { user, isAuthenticated } = useAuth0();
  const { userId, blogUrl, setBlogUrl, setUserId } = useUserStore();
  const [successMessage, setSuccessMessage] = useState(false);
  const [integrations, setIntegrations] = useState([]);
  const [loadingIntegrations, setLoadingIntegrations] = useState(true);
  const [tutorialStarted, setTutorialStarted] = useState(false);
  const [hasSeenTutorial, setHasSeenTutorial] = useState(false);
  const [loadingUpgrade, setLoadingUpgrade] = useState(false); // New loading state
  const [userData, setUserData] = useState(null); // New state for user data
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // State to track mobile view
  const [autoPublish, setAutoPublish] = useState(false); // State for auto-publish checkbox
  const [keywords, setKeywords] = useState([]);
  const [editedKeywords, setEditedKeywords] = useState({});
  const [loadingKeywords, setLoadingKeywords] = useState(true);
  const [webhookUrl, setWebhookUrl] = useState('');
  const [activeTab, setActiveTab] = useState('general');
  const [showBanner, setShowBanner] = useState(true);
  const [newKeyword, setNewKeyword] = useState('');
  const [keywordLoading, setKeywordLoading] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false); // State for edit modal
  const [selectedKeyword, setSelectedKeyword] = useState(null);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [feedbackType, setFeedbackType] = useState(''); // 'feature', 'bug', 'other'
  const [message, setMessage] = useState('');
  const [isCancelConfirmationOpen, setIsCancelConfirmationOpen] = useState(false); // New state for cancel confirmation modal
  const [blogSummary, setBlogSummary] = useState(''); // New state for blog summary
  const [editSummary, setEditSummary] = useState(false);
  const [notificationEnabled, setNotificationEnabled] = useState(false); // NEW STATE FOR NOTIFICATIONS
  const [selectedKeywords, setSelectedKeywords] = useState([]);


  const handleSelectKeyword = (keywordId) => {
    setSelectedKeywords((prevSelected) =>
      prevSelected.includes(keywordId)
        ? prevSelected.filter((id) => id !== keywordId) // Unselect keyword
        : [...prevSelected, keywordId] // Select keyword
    );
  };

  const handleDeleteSelectedKeywords = async () => {
    if (selectedKeywords.length === 0) {
      toast.error("Please select at least one keyword to delete.");
      return;
    }

    try {
      setLoading(true);

      // Get the blog ID (use the correct API to fetch the blog ID if needed)
      const response1 = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/user/${userId}/blogs/`);
      const blog_id = response1.data.blogs[0].id;

      // Make API call to delete the selected keywords
      const response = await axios.delete(
        `https://trendhopper-c3934b7293e6.herokuapp.com/blogs/${blog_id}/keywords/delete/`,
        {
          data: { keyword_ids: selectedKeywords }
        }
      );

      if (response.data.status === 'success') {
        toast.success("Selected keywords deleted successfully!");

        // Refetch keywords after successful delete
        const keywordsResponse = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/blogs/${blog_id}/keywords/`);
        setKeywords(keywordsResponse.data.keywords || []);
        setSelectedKeywords([]); // Clear selected keywords
      } else {
        toast.error(response.data.message || 'Failed to delete selected keywords.');
      }
    } catch (err) {
      setError('Failed to delete selected keywords.');
      toast.error('Failed to delete selected keywords.');
    } finally {
      setLoading(false);
    }
  };


  // Check if there are any integrations connected
  const hasIntegrations = integrations && integrations.length > 0;
  const openFeedbackModal = () => setShowFeedbackModal(true);
  const closeFeedbackModal = () => {
    setShowFeedbackModal(false);
    setFeedbackType('');  // Clear the selection
    setMessage('');       // Clear the message
  }

  const openCancelConfirmationModal = () => setIsCancelConfirmationOpen(true);
  const closeCancelConfirmationModal = () => setIsCancelConfirmationOpen(false);
  const closeDropdown = () => setIsDropdownOpen(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State for managing dropdown visibility


  const handleFeedbackSubmit = async () => {
    if (!message.trim()) {
      alert("Please enter your feedback before submitting.");
      return;
    }

    try {
      const email = user.email
      console.log('the email', email)
      const response = await fetch("https://trendhopper-c3934b7293e6.herokuapp.com/send_feedback_email/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_email: email,  // Get email from Auth0
          feedback: feedbackType + '_______ ' + message.trim(),
        }),
      });

      if (!response.ok) throw new Error("Failed to submit feedback");

      toast("✅Feedback submitted successfully!");
      closeFeedbackModal(); // Close modal after submission
      setMessage(""); // Reset message input
    } catch (error) {
      console.error("Error submitting feedback:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  const handleFeedbackTypeSelect = (type) => {
    setFeedbackType(type);
  };

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

   // New function to open the edit modal and set the selected keyword
   const openEditModal = (keyword) => {
    setSelectedKeyword(keyword);
    setEditModalOpen(true);
  };

  // Function to close the edit modal
  const closeEditModal = () => {
    setEditModalOpen(false);
    setSelectedKeyword(null);
  };


  // Function to handle saving the edited keyword
  const handleSaveEditedKeyword = async () => {
    setLoading(true);
    setError(null);

    console.log('selectedKeyword', selectedKeyword)
    try {
      // Make API call to update the keyword
      await axios.post(
        `https://trendhopper-c3934b7293e6.herokuapp.com/keywords/${selectedKeyword.id}/update/`,
        JSON.stringify({ keyword: selectedKeyword.keyword }),
        { headers: { 'Content-Type': 'application/json' } }
      );
      setEditedKeywords({}); //
      toast.success('Keyword updated successfully!');

      // Refetch keywords after successful update
      const response1 = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/user/${userId}/blogs/`);
      const blog_id = response1.data.blogs[0].id;
      const keywordsResponse = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/blogs/${blog_id}/keywords/`);

      setKeywords(keywordsResponse.data.keywords || []);
    } catch (err) {
      setError('Failed to update keyword.');
      toast.error('Failed to update keyword.');
    } finally {
      setLoading(false);
      closeEditModal(); // Close the modal after saving
    }
  };

  const handleSaveKeywords = async () => {
    setLoading(true);
    setError(null);

    try {
      const keywordsToUpdate = keywords.filter(keyword => editedKeywords[keyword.id]);

      const updatePromises = keywordsToUpdate.map(async (keyword) => {
        await axios.post(
          `https://trendhopper-c3934b7293e6.herokuapp.com/keywords/${keyword.id}/update/`,
          JSON.stringify({ keyword: keyword.keyword }),
          { headers: { 'Content-Type': 'application/json' } }
        );
      });

      await Promise.all(updatePromises);
      setEditedKeywords({}); // Clear edited state
      toast.success('Keywords updated successfully!');

      // Refetch keywords after successful update
      const response1 = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/user/${userId}/blogs/`);
      const blog_id = response1.data.blogs[0].id;
      const keywordsResponse = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/blogs/${blog_id}/keywords/`);
      setKeywords(keywordsResponse.data.keywords || []);
    } catch (err) {
      setError('Failed to update keywords.');
      toast.error('Failed to update keywords.');
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const fetchUserIdAndData = async () => {
      const storedUserId = localStorage.getItem('userId');

      if (isAuthenticated && user?.email) {
        try {
          if (!storedUserId) {
            // Fetch userId if not found in localStorage
            console.log('Fetching user ID', user.email);
            const response = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/users/exist/${user.email}/`);
            const fetchedUserId = response.data.user_id;
            console.log('fetchedUserId', fetchedUserId);

            // Save userId in the global store and local storage
            setUserId(fetchedUserId);
            localStorage.setItem('userId', fetchedUserId);
          } else {
            // Use userId from localStorage
            setUserId(storedUserId);
          }

          // Always fetch user data regardless of storedUserId
          const userResponse = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/get-user/${user.email}/`);
          const userData = userResponse.data;
          console.log('userData', userData.view_tutorial_seen);
          setHasSeenTutorial(userData.view_tutorial_seen);
        } catch (err) {
          setError('Failed to fetch user ID or user data');
          console.error(err);
        }
      }
    };

    fetchUserIdAndData();
  }, [isAuthenticated, user, setUserId]);

  const handleAddKeyword = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!newKeyword.trim()) {
        toast.error('Keyword cannot be empty.');
        return;
      }

      const response1 = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/user/${userId}/blogs/`);
      const blog_id = response1.data.blogs[0].id;

      await axios.post(
        `https://trendhopper-c3934b7293e6.herokuapp.com/blogs/${blog_id}/keywords/add/`,
        JSON.stringify({ keyword: newKeyword }),
        { headers: { 'Content-Type': 'application/json' } }
      );

      toast.success('Keyword added successfully!');
      setNewKeyword(''); // Clear the input field
      // Refetch keywords after successful add
      const keywordsResponse = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/blogs/${blog_id}/keywords/`);
      setKeywords(keywordsResponse.data.keywords || []);
    } catch (err) {
      setError('Failed to add keyword.');
      toast.error('Failed to add keyword.');
    } finally {
      setLoading(false);
      setIsModalOpen(false); // Close modal after adding
    }
  };

  const handleDeleteKeyword = async (keywordId) => {
    setKeywordLoading(prevLoading => ({ ...prevLoading, [keywordId]: true }));
    setError(null);

    try {
      const response1 = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/user/${userId}/blogs/`);
      const blog_id = response1.data.blogs[0].id;

      await axios.delete(
        `https://trendhopper-c3934b7293e6.herokuapp.com/blogs/${blog_id}/keywords/${keywordId}/delete/`
      );

      toast.success('Keyword deleted successfully!');
      // Refetch keywords after successful delete
      const keywordsResponse = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/blogs/${blog_id}/keywords/`);
      setKeywords(keywordsResponse.data.keywords || []);
    } catch (err) {
      setError('Failed to delete keyword.');
      toast.error('Failed to delete keyword.');
    } finally {
      setKeywordLoading(prevLoading => {
        const { [keywordId]: deleted, ...rest } = prevLoading;
        return rest;
      });
    }
  };
  const handleTestIntegration = async (platform, integrationId) => {
    setLoading(true);
    setError(null);

    try {
      let testData = {
        platform: platform,
        api_url: platform === 'ghost' ? ghostUrl : platform === 'wordpress' ? wordpressUrl : null,
    };

        if (platform === 'ghost') {
            testData = {
                ...testData,
                admin_api_key: adminApiKey,
                content_api_key: ghostApiKey,
            };
        } else if (platform === 'wordpress') {
            testData = {
                ...testData,
                wordpress_username: wordpressUsername,
                wordpress_password: wordpressPassword,
            };
        }

        if (integrationId) {
            testData.integration_id = integrationId;
        }

        const response = await axios.post(
            `https://trendhopper-c3934b7293e6.herokuapp.com/test-integration/`,
            testData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json', // Added Accept header
                },
            }
        );

        // Handle success response
        if (response?.status === 200) {
            const message = response.data?.message || 'Integration test successful!';
            toast.success(message); // Display success message
        } else {
            const error = response.data?.error || 'Integration test failed. Please check your credentials.';
            toast.error(error); // Display error message
        }
    } catch (err) {
        console.error('Error testing integration:', err);

        // Handle different error cases
        const errorMessage =
            err.response?.data?.error || // Error from backend
            err.message || // Generic error message
            'Error testing integration. Please try again.';
        toast.error(`Error: ${errorMessage}`);
    } finally {
        setLoading(false);
    }
};


useEffect(() => {
  // Only run the intro.js tutorial once integrations are fully loaded and only if the user hasn't seen it
  if (!hasSeenTutorial && !tutorialStarted && !loadingIntegrations) {
    const intro = IntroJs();

    intro.setOptions({
      steps: [
        { element: '#step1', intro: 'Welcome to the Settings page! Let\'s walk you through this.' },
        { element: '#step2', intro: 'This is where you can see your configured blog URL i.e your website.' },
        {
          element: '#step3',
          intro: "In this step, you can integrate with platforms like Ghost, WordPress, or set up a webhook. Once connected, simply toggle Auto-publish, and we will take care of posting the articles for you automatically",
        },
        {
          element: '#step4',
          intro: 'The Keywords tab lets you add, edit, or delete keywords for Trendhopper to target. You can also view the metrics for each keyword you add.'
        }
      ],
      showStepNumbers: false,
      exitOnOverlayClick: true,
      nextLabel: 'Next',
      prevLabel: 'Back',
      skipLabel: 'X',
      doneLabel: 'Done',
    });

    const markTutorialAsSeen = async () => {
      try {
        if (userId) {
          console.log('Marking tutorial as seen for user:', user.email);
          await axios.post(`https://trendhopper-c3934b7293e6.herokuapp.com/mark-view-tutorial-seen/${user.email}/`, {
            view_tutorial_seen: true,
          });
          setHasSeenTutorial(true); // Update the local state after marking it on the server
        }
      } catch (err) {
        console.error('Error marking tutorial as seen:', err);
      }
    };

    intro.oncomplete(markTutorialAsSeen);
    intro.onskip(markTutorialAsSeen);

    intro.start();
    setTutorialStarted(true); // Mark the tutorial as started to prevent running it again
  }
}, [hasSeenTutorial, tutorialStarted, loadingIntegrations, userId, user.email]);



  useEffect(() => {
    // Fetch blog URL once userId is available
    const fetchUserBlogUrl = async () => {
      if (!userId) {
        console.error('userId is not set');
        return;
      }
      try {
        const response = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/user/${userId}/blogs/`);
        const blogs = response.data.blogs || [];
        if (blogs.length === 0) {
          console.warn('No blogs found for the user');
          setBlogUrl(''); // Clear any existing blogUrl
          setLoadingIntegrations(false);
          setBlogSummary(''); // Clear blog summary as well
          return;
        }

        const url = blogs[0].url || '';
        setBlogUrl(url);
        setBlogSummary(blogs[0].summary || ''); // Set blog summary from fetched data - **PRE-LOADS SUMMARY HERE**
        const blogId = blogs[0].id;
        // NEW - set notificationEnabled state from blog data
        console.log("NOTIFICATIONS ENABLED: ", blogs[0].notification_enabled)
        setNotificationEnabled(blogs[0].notification_enabled || false);


        const fetchedIntegrations = await fetchIntegrations(blogId);
        setIntegrations(fetchedIntegrations);
        setLoadingIntegrations(false);

        // Set autoPublish state based on the fetched blog data
        setAutoPublish(blogs[0].auto_publish || false);

        // Fetch keywords
        const keywordsResponse = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/blogs/${blogId}/keywords/`);
        setKeywords(keywordsResponse.data.keywords || []);
        setLoadingKeywords(false);

        if (fetchedIntegrations.length > 0) {
          fetchedIntegrations.forEach(integration => {
              if (integration.platform === 'ghost') {
                  setGhostApiKey(integration.content_api_key || '');
                  setAdminApiKey(integration.admin_api_key || '');
                  setGhostUrl(integration.api_url || '');
              } else if (integration.platform === 'wordpress') {
                  setWordpressUsername(integration.wordpress_username || '');
                  setWordpressPassword(integration.wordpress_password || '');
                  setWordpressUrl(integration.api_url || '');
              } else if (integration.platform === 'webhook') {
                  setWebhookUrl(integration.webhook_url || '');
              }
          });
      }
      } catch (err) {
        setError('Failed to fetch blog URL, integrations, or keywords');
        console.error(err);
      }
    };


    fetchUserBlogUrl();
  }, [userId]);

  useEffect(() => {
    // Fetch user data including subscription end date
    const fetchUserData = async () => {
      if (userId) {
        try {
          const response = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/get-user/${user.email}/`);
          setUserData(response.data);
        } catch (err) {
          setError('Failed to fetch user data');
        }
      }
    };

    fetchUserData();
  }, [userId]);

  const handleIntegrationSubmit = async (platform) => {
    setLoading(true);
    setError(null);

    try {
      const response1 = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/user/${userId}/blogs/`);
      const url = response1.data.blogs[0]?.url || '';
      const blog_id = response1.data.blogs[0].id;

      let integrationData = {
        url: url,
        type: platform,
        blog_id: blog_id,
        api_url: platform === 'ghost' ? ghostUrl : platform === 'wordpress' ? wordpressUrl : null,
        webhook_url: platform === 'webhook' ? webhookUrl : null,
    };

      if (platform === 'ghost') {
        integrationData = {
          ...integrationData,
          content_api_key: ghostApiKey,
          admin_api_key: adminApiKey,
        };
      } else if (platform === 'wordpress') {
        integrationData = {
          ...integrationData,
          wordpress_username: wordpressUsername,
          wordpress_password: wordpressPassword,
        };
      }

      // Check if an integration already exists for this platform
      const existingIntegration = integrations.find(int => int.platform === platform);

      let response;
      if (existingIntegration) {
        // Update existing integration
        response = await axios.put(
          `https://trendhopper-c3934b7293e6.herokuapp.com/integrations/${existingIntegration.id}/`,
          integrationData,
          { headers: { 'Content-Type': 'application/json' } }
        );
      } else {
        // Create new integration
        response = await axios.post(
          `https://trendhopper-c3934b7293e6.herokuapp.com/integrate/`,
          integrationData,
          { headers: { 'Content-Type': 'application/json' } }
        );
      }


      if (response.status === 200 || response.status === 201) {
        toast.success(`${platform.charAt(0).toUpperCase() + platform.slice(1)} integration ${existingIntegration ? 'updated' : 'successful'}!`);

        // After successful integration, update integrations state to reflect the new status
        setIntegrations(prevIntegrations => {
          const newIntegration = { ...integrationData, platform: platform };
          // Check if an integration of this platform already exists
          const existingIndex = prevIntegrations.findIndex(int => int.platform === platform);
          if (existingIndex > -1) {
            // Replace existing integration
            const updatedIntegrations = [...prevIntegrations];
            updatedIntegrations[existingIndex] = { ...updatedIntegrations[existingIndex], ...newIntegration };
            return updatedIntegrations;
          } else {
            // Add new integration
            return [...prevIntegrations, newIntegration];
          }
        });
      }
    } catch (err) {
      setError(`Failed to integrate ${platform.charAt(0).toUpperCase() + platform.slice(1)}`);
      toast.error(`Failed to integrate ${platform.charAt(0).toUpperCase() + platform.slice(1)}`);
    } finally {
      setLoading(false);
    }
  };

  const handleUpgradeClick = async () => {
    setLoadingUpgrade(true);
    setError(null);

    try {
      // Call the Django backend to create a checkout session
      const response = await axios.post(
        'https://trendhopper-c3934b7293e6.herokuapp.com/create-checkout-session/',
        { email: user.email }, // Send the email in the request body
        { headers: { 'Content-Type': 'application/json' } }
      );

      const session = response.data;

      if (session && session.id) {
        const stripe = await stripePromise;

        // Redirect to Stripe Checkout
        const { error } = await stripe.redirectToCheckout({
          sessionId: session.id,
        });

        if (error) {
          console.error('Error redirecting to checkout:', error);
          setError('Failed to redirect to checkout.');
        }
      } else {
        setError('Failed to create Stripe checkout session.');
      }
    } catch (err) {
      // Improved error handling
      if (err.response && err.response.data && err.response.data.error) {
        setError(`Server Error: ${err.response.data.error}`);
        console.error('Error during upgrade:', err.response.data.error);
      } else if (err.request) {
        setError('No response received from server.');
        console.error('Error during upgrade: No response from server', err.request);
      } else {
        setError('Failed to initiate upgrade process.');
        console.error('Error during upgrade:', err);
      }
    } finally {
      setLoadingUpgrade(false);
    }
  };

  const handleCancelSubscription = async () => {
    console.log("handleCancelSubscription CALLED");
    setLoadingUpgrade(true);
    setError(null);

    try {
      if (userData && userData.stripe_customer_id) { // Changed to use stripe_customer_id
        console.log("Customer ID found:", userData.stripe_customer_id); // ADDED CONSOLE LOG
        await axios.post(
          'https://trendhopper-c3934b7293e6.herokuapp.com/cancel-subscription/',
          {
            stripe_customer_id: userData.stripe_customer_id, // Changed to send stripe_customer_id
          },
          { headers: { 'Content-Type': 'application/json' } }
        );
        // After successful cancellation, fetch user data again to update the UI
        const response = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/get-user/${user.email}/`);
        setUserData(response.data);
        toast.success('Subscription cancelled successfully.');
      } else {
        console.log("No customer ID found."); // ADDED CONSOLE LOG
        setError('No customer ID found to cancel.');
        toast.error('No customer ID found to cancel.');
      }
    } catch (err) {
      setError('Failed to cancel subscription.');
      console.error('Error during cancellation:', err);
      toast.error('Failed to cancel subscription.');
    } finally {
      setLoadingUpgrade(false);
    }
  };

  const isNonTrialSubscriptionActive = () => {
    if (userData && userData.subscription_end_date && userData.stripe_customer_id) {
      const endDate = new Date(userData.subscription_end_date);
      return endDate > new Date();
    }
    return false;
  };


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Helper function to get integration ID or null if not found
  const getIntegrationId = (platform) => {
    const integration = integrations.find(int => int.platform === platform);
    return integration ? integration.id : null;
  };

  const handleAutoPublishChange = async (event) => {
    const newAutoPublishValue = event.target.checked;
    setAutoPublish(newAutoPublishValue);

    try {
      const response1 = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/user/${userId}/blogs/`);
      const blog_id = response1.data.blogs[0].id;

      await axios.post(
        `https://trendhopper-c3934b7293e6.herokuapp.com/blogs/${blog_id}/update_auto_publish/`,
        { auto_publish: newAutoPublishValue },
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );
      toast.success(`Auto-publish updated to ${newAutoPublishValue ? 'enabled' : 'disabled'}`);
    } catch (err) {
      setError('Failed to update auto-publish setting.');
      toast.error('Failed to update auto-publish setting.');
      // Revert the checkbox if the update fails
      setAutoPublish(!newAutoPublishValue);
    }
  };

  const handleKeywordChange = (index, event) => {
    const newKeywords = [...keywords];
    newKeywords[index].keyword = event.target.value;
    setKeywords(newKeywords);

    // Mark keyword as edited
    setEditedKeywords(prevEdited => ({
      ...prevEdited,
      [newKeywords[index].id]: true,
    }));
  };

  const handleBlogUrlChange = (event) => {
    setBlogUrl(event.target.value);
  };

  const handleSummaryChange = (event) => {
    setBlogSummary(event.target.value);
  };

  const handleSaveBlogSettings = async () => { // Renamed function
    setLoading(true);
    setError(null);
    try {
      const response1 = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/user/${userId}/blogs/`);
      const blog_id = response1.data.blogs[0].id;

      await axios.post(
        `https://trendhopper-c3934b7293e6.herokuapp.com/blogs/${blog_id}/update_url_summary/`, // Updated endpoint
        JSON.stringify({ url: blogUrl, summary: blogSummary }), // Send both URL and summary
        { headers: { 'Content-Type': 'application/json' } } // Changed headers to application/json
      );
      toast.success('Blog settings updated successfully!'); // Updated success message
    } catch (err) {
      setError('Failed to update blog settings.'); // Updated error message
      toast.error('Failed to update blog settings.'); // Updated error message
    } finally {
      setLoading(false);
    }
  };

  // NEW FUNCTION TO TOGGLE NOTIFICATIONS
  const handleNotificationToggle = async () => {
    const newNotificationValue = !notificationEnabled;
    setNotificationEnabled(newNotificationValue);

    try {
      const response1 = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/user/${userId}/blogs/`);
      const blog_id = response1.data.blogs[0].id;

      const response = await axios.post(
        `https://trendhopper-c3934b7293e6.herokuapp.com/blogs/${blog_id}/toggle_notifications/`, // Use the new endpoint
        {}, // No data needed for toggle
        { headers: { 'Content-Type': 'application/json' } } // Set content type to JSON
      );

      if (response.data.status === 'success') {
        toast.success(`Notifications updated to ${newNotificationValue ? 'enabled' : 'disabled'}`);
      } else {
        toast.error(`Failed to update notification setting: ${response.data.message}`);
        setNotificationEnabled(!newNotificationValue); // Revert on failure
      }
    } catch (err) {
      setError('Failed to update notification setting.');
      toast.error('Failed to update notification setting.');
      setNotificationEnabled(!newNotificationValue); // Revert on error
    }
  };


  const getCompetitionColor = (competition) => {
    switch (competition) {
        case "HIGH":
            return "text-red-500"; // Red for high competition
        case "MEDIUM":
            return "text-yellow-400"; // Yellow for medium competition
        case "LOW":
            return "text-green-400"; // Green for low competition
        default:
            return "text-gray-400"; // Gray for undefined values
    }
};
const getCompetitionIconColor = (competition) => {
  switch (competition) {
      case "HIGH":
          return "text-red-500"; // High competition = Red icon
      case "MEDIUM":
          return "text-yellow-400"; // Medium competition = Yellow icon
      case "LOW":
          return "text-green-400"; // Low competition = Green icon
      default:
          return "text-gray-400"; // Undefined values = Gray icon
  }
};


const renderKeywordMetrics = (keyword) => {
  return (
      <div className="mt-2 grid grid-cols-2 gap-2 text-sm">
          <div className="flex flex-col items-start">
              <span className="text-gray-400 font-medium">Search Volume</span>
              <div className="flex items-center gap-1">
                  <FaChartLine className="text-blue-400" />
                  <span className="text-gray-300 font-medium text-base">
                      {keyword.search_volume_msv || 'N/A'}
                  </span>
              </div>
          </div>
          <div className="flex flex-col items-start">
              <span className="text-gray-400 font-medium">Difficulty</span>
              <div className="flex items-center gap-1">
                  <FaTachometerAlt className="text-purple-400" />
                  <span className="text-gray-300 font-medium text-base">
                      {keyword.keyword_difficulty || 'N/A'}
                  </span>
              </div>
          </div>
          <div className="flex flex-col items-start">
              <span className="text-gray-400 font-medium">Competition</span>
              <div className="flex items-center gap-1">
                  <FaUsers className={getCompetitionColor(keyword.competition)} />
                  <span className={`font-medium text-base ${getCompetitionColor(keyword.competition)}`}>
                      {keyword.competition || 'N/A'}
                  </span>
              </div>
          </div>
          <div className="flex flex-col items-start">
              <span className="text-gray-400 font-medium">CPC</span>
              <div className="flex items-center gap-1">
                  <FaDollarSign className="text-orange-400" />
                  <span className="text-gray-300 font-medium text-base">
                      {keyword.cpc || 'N/A'}
                  </span>
              </div>
          </div>
      </div>
  );
};

  const handleCancelSubscriptionConfirmation = async (confirmed) => {
    console.log("handleCancelSubscriptionConfirmation CALLED with confirmed:", confirmed);
    closeCancelConfirmationModal(); // Close confirmation modal regardless of action

    if (confirmed) {
      // Proceed with cancellation if confirmed
      await handleCancelSubscription();
    }
    // If not confirmed, do nothing, just close the modal
  };


  return (
    <div className={`w-full ${isMobile ? 'pt-12' : ''}`}>
      <div  className="">
      <div id="step1" className="mb-2 flex justify-between items-center">
        <h1 className="text-3xl font-bold text-white flex items-center gap-2">
          <span>Settings</span>
        </h1>
      </div>
        {/* Tabs */}
        <div className="flex border-b border-slate-700 mb-4">
          <button
            onClick={() => setActiveTab('general')}
            className={`px-4 py-2 text-sm font-medium text-white ${activeTab === 'general' ? 'border-b-2 border-purple-500' : 'hover:bg-slate-700/50'}`}
          >
            General
          </button>
          <button
            id="step3"
            onClick={() => setActiveTab('integrations')}
            className={`px-4 py-2 text-sm font-medium text-white ${activeTab === 'integrations' ? 'border-b-2 border-purple-500' : 'hover:bg-slate-700/50'}`}
          >
            Integrations
          </button>
          <button
        id="step4"
        onClick={() => setActiveTab('keywords')}
        className={`px-4 py-2 text-sm font-medium text-white flex items-center space-x-2 ${
          activeTab === 'keywords' ? 'border-b-2 border-purple-500' : 'hover:bg-slate-700/50'
        }`}
      >
        <span>Keywords</span>
        {keywords.length > 0 && (
          <span className="bg-blue-500 text-white text-xs font-semibold px-3 py-1 rounded-md">
            {keywords.length}
          </span>
        )}
      </button>

        </div>
        {/* Tab Content */}
        {activeTab === 'general' && (
  <div className="space-y-6">
    {/* Combined Website URL, Summary and Notification Section */}
    <div className="rounded-lg">
      <div className="flex justify-between items-start mb-4">
        <div>
        <h3 className="text-lg font-semibold text-white">Settings</h3>
        </div>
      </div>

      {/* Website URL */}
      <div className="mb-4">
        <label htmlFor="url" className="block text-sm font-medium text-slate-200">Website URL</label>
        <p className="text-sm text-slate-400"> Your site</p>

        <input
          value={blogUrl}
          onChange={handleBlogUrlChange} // Use new handler for URL change
          type="text"
          id="url"
          placeholder="https://example.com"
          className="w-full px-3 py-2 mt-1 bg-slate-900/50 border border-slate-700 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
      </div>

        <label className="block text-sm font-medium text-slate-200 flex items-center ">
            Blog Summary
            <button
            onClick={() => setEditSummary(true)} // Show the textarea when Edit button is clicked
            className="text-blue-400 flex items-center ml-2 hover:text-blue-300 text-sm"
          >
            <FaEdit className="mr-1" /> {/* Adjusted margin */}
            Edit
          </button>
        </label>
          <p className="text-sm text-slate-400">Manage your blog summary</p>

          {/* Only show textarea when editing */}
          {editSummary ? (
            <div>
              <Textarea
                id="summary"
                value={blogSummary}
                onChange={handleSummaryChange}
                placeholder="Enter a summary of your blog..."
                rows={4}
                className="w-full px-3 py-2 mt-1 bg-slate-900/50 border border-slate-700 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-purple-500 resize-none"
              />
              <div className="mt-4 flex justify-end">
              <button
  onClick={() => {
    closeDropdown(); // Close dropdown if open
    setEditSummary(false); // Close the edit mode
  }}
  className="bg-gray-500 mr-2 hover:bg-gray-600 text-white font-semibold rounded-md flex items-center justify-center px-6 py-2"
>
  <FaTimes className="mr-2" /> {/* Cancel Icon */}
  <span>Cancel</span>
</button>

<button
  onClick={handleSaveBlogSettings} // Call the existing save function
  className="bg-purple-500 hover:bg-purple-600 text-white font-semibold rounded-md transition-colors flex items-center justify-center px-6 py-2"
  disabled={loading}
>
  {loading ? (
    <>
      <span>Saving...</span>
    </>
  ) : (
    <>
      <FaSave className="mr-2" /> {/* Save Icon */}
      <span>Save Blog</span>
    </>
  )}
</button>


              </div>
            </div>
          ) : (

<textarea
  id="summary"
  value={blogSummary || "No summary provided yet."}
  onChange={handleSummaryChange}
  disabled
  className="w-full px-3 py-2 mt-1 bg-slate-900/50 border border-slate-700 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-purple-500 resize-none break-words"
  style={{ wordWrap: 'break-word' }}
/>

          )}
                <div className="flex">
          <div className="mt-4 flex items-center space-x-2">
            <span className="text-sm font-medium text-slate-200">Draft Notifications</span>
            <div
              className={`relative w-12 h-6 rounded-full cursor-pointer transition-all duration-300 ${
                notificationEnabled ? "bg-green-500" : "bg-gray-700"
              }`}
              onClick={handleNotificationToggle}
            >
              <div
                className={`absolute w-5 h-5 bg-white rounded-full top-[3px] transition-transform duration-300 ${
                  notificationEnabled ? "translate-x-6" : "translate-x-1"
                }`}
              ></div>
            </div>
          </div>
        </div>
        <p className="text-sm text-slate-400">Recieve an email when an article is ready to be edited.</p>
    </div>


    {/* Upgrade Section */}
    <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-6 flex items-center justify-between">
      <div>
        <h3 className="text-lg font-bold text-white">Upgrade to Pro</h3>
        <p className="text-sm text-slate-400">Continue using the platform and unlock premium features</p> {/* Updated text */}
        </div>
  {/* Upgrade to Pro Button */}
<button
  onClick={isNonTrialSubscriptionActive() ? openCancelConfirmationModal : handleUpgradeClick}
  className={`px-6 py-3 ${loadingUpgrade ? 'bg-gradient-to-r from-purple-400 via-purple-500 to-purple-600 text-white' : 'bg-purple-500 hover:bg-purple-600 text-white'} font-semibold rounded-md transition-colors ${isMobile ? 'text-sm' : 'text-base'}`}
  disabled={loadingUpgrade}
>
  {loadingUpgrade ? (
    'Loading...'
  ) : isNonTrialSubscriptionActive() ? (
    <>
      <FaStar className="inline mr-2" />
      Cancel
    </>
  ) : (
    <>
      <FaPlusCircle className="inline mr-2" />
      Upgrade Now
    </>
  )}
</button>



    </div>
  </div>
)}

        {activeTab === 'integrations' && (
          <div className="space-y-6">
            <div className="space-y-4">
            <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                Integrations
                <span
                  data-tooltip-id="integrations-tooltip"
                  className="cursor-pointer"
                >
                  <FaInfoCircle className="text-gray-400 hover:text-gray-300" size={16} />
                </span>
                <Tooltip
                id="integrations-tooltip"
                place="top"
                effect="solid"
                className="bg-slate-800 text-white px-3 py-2 rounded-md text-sm max-w-[300px] z-50"
              >
                Enable the Auto Publish toggle to automatically publish your content. You need to have an integration enabled (e.g., WordPress, Ghost) before using this feature.
              </Tooltip>
              </h3>
              <div className="flex items-center justify-between p-4 rounded-lg bg-slate-900/50 border border-slate-700">
                <div className="flex items-center space-x-2">
                  <label
                    htmlFor="auto-publish-toggle"
                    className="text-sm font-medium text-slate-200"
                    title="Enable to auto-publish your blogs. Disable to publish as drafts."
                  >
                    Auto Publish
                  </label>
              <div
                className={`relative w-12 h-6 rounded-full cursor-pointer transition-all duration-300 ${
                  autoPublish ? "bg-green-500" : "bg-gray-700"
                } ${!hasIntegrations ? 'opacity-50 pointer-events-none cursor-not-allowed' : ''}`} // Disable and visually indicate if no integrations
                onClick={hasIntegrations ? () => handleAutoPublishChange({ target: { checked: !autoPublish } }) : null} // Only toggle if integrations are connected
              >
                <div
                  className={`absolute w-5 h-5 bg-white rounded-full top-[3px] transition-transform duration-300 ${
                    autoPublish ? "translate-x-6" : "translate-x-1"
                  }`}
                ></div>
              </div>
                </div>
              </div>

              {/* Integrations Accordions */}
              <div className="space-y-4">
                {/* Ghost Integration */}
                <div className="bg-slate-800/50 border border-slate-700 rounded-lg">
                  <button
                    type="button"
                    className="flex items-center justify-between w-full p-4 text-left text-white"
                    onClick={() => toggleAccordion(0)}
                    id="accordion-open-heading-1"
                  >
                    <div className="flex items-center">
                      <FaGhost className="mr-2 text-xl" />
                      <h5 className="font-semibold text-white">Ghost</h5>
                    </div>
                    {openAccordion === 0 ? <FaChevronUp /> : <FaChevronDown />}
                  </button>
                  <div id="accordion-open-body-1" className={`${openAccordion === 0 ? 'block' : 'hidden'} p-4`}>
                    <p className="mb-2 text-sm text-gray-400">
                      Connect to your Ghost blog to enable automatic publishing of your content.
                    </p>
                    <div className="space-y-4">
                      <div>
                        <label htmlFor="ghostUrl" className="block mb-2 text-sm font-medium text-slate-200">Ghost API URL</label>
                        <input type="text" id="ghostUrl" className="bg-slate-900/50 border border-slate-700 text-white text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-purple-500 dark:focus:border-purple-500" placeholder="e.g., https://yourghostblog.com" value={ghostUrl} onChange={(e) => setGhostUrl(e.target.value)} />
                      </div>
                      <div>
                        <label htmlFor="adminApiKey" className="block mb-2 text-sm font-medium text-slate-200">Ghost Admin API Key</label>
                        <input type="password" id="adminApiKey" className="bg-slate-900/50 border border-slate-700 text-white text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-purple-500 dark:focus:border-purple-500" placeholder="••••••••" value={adminApiKey} onChange={(e) => setAdminApiKey(e.target.value)} />
                      </div>
                      <div>
                        <label htmlFor="ghostApiKey" className="block mb-2 text-sm font-medium text-slate-200">Ghost Content API Key</label>
                        <input type="password" id="ghostApiKey" className="bg-slate-900/50 border border-slate-700 text-white text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-purple-500 dark:focus:border-purple-500" placeholder="••••••••" value={ghostApiKey} onChange={(e) => setGhostApiKey(e.target.value)} />
                      </div>
                      <div className="flex justify-end">
                        <Button
                          onClick={() => handleIntegrationSubmit('ghost')}
                          className="bg-purple-500 hover:bg-purple-600 text-white font-semibold rounded-md transition-colors flex items-center"
                          disabled={loading}
                        >
                          {loading && activeTab === 'integrations' ? (
                            <FaSpinner className="mr-2 animate-spin" />
                          ) : 'Save Ghost Settings'}
                        </Button>
                        <Button
                          color="gray"
                          className="ml-2"
                          onClick={() => handleTestIntegration('ghost', getIntegrationId('ghost'))}
                          disabled={loading}
                        >
                          {loading && activeTab === 'integrations' ? (
                            <FaSpinner className="mr-2 animate-spin" />
                          ) : 'Test Integration'}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* WordPress Integration */}
                <div className="bg-slate-800/50 border border-slate-700 rounded-lg">
                  <button
                    type="button"
                    className="flex items-center justify-between w-full p-4 text-left text-white"
                    onClick={() => toggleAccordion(1)}
                    aria-controls="accordion-open-body-2"
                    aria-expanded={openAccordion === 1}
                  >
                    <div className="flex items-center">
                      <FaWordpress className="mr-2 text-xl" />
                      <h5 className="font-semibold text-white">WordPress</h5>
                    </div>
                    {openAccordion === 1 ? <FaChevronUp /> : <FaChevronDown />}
                  </button>
                  <div id="accordion-open-body-2" className={`${openAccordion === 1 ? 'block' : 'hidden'} p-4`} aria-labelledby="accordion-open-heading-2">
                    <p className="mb-2 text-sm text-gray-400">
                      Connect to your WordPress site to automatically publish your content.
                    </p>
                    <div className="space-y-4">
                      <div>
                        <label htmlFor="wordpressUrl" className="block mb-2 text-sm font-medium text-slate-200">WordPress URL</label>
                        <input type="text" id="wordpressUrl" className="bg-slate-900/50 border border-slate-700 text-white text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-purple-500 dark:focus:border-purple-500" placeholder="e.g., https://yourwordpresssite.com" value={wordpressUrl} onChange={(e) => setWordpressUrl(e.target.value)} />
                      </div>
                      <div>
                        <label htmlFor="wordpressUsername" className="block mb-2 text-sm font-medium text-slate-200">WordPress Username</label>
                        <input type="text" id="wordpressUsername" className="bg-slate-900/50 border border-slate-700 text-white text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-purple-500 dark:focus:border-purple-500" placeholder="Username" value={wordpressUsername} onChange={(e) => setWordpressUsername(e.target.value)} />
                      </div>
                      <div>
                        <label htmlFor="wordpressPassword" className="block mb-2 text-sm font-medium text-slate-200">WordPress Password</label>
                        <input type="password" id="wordpressPassword" className="bg-slate-900/50 border border-slate-700 text-white text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-purple-500 dark:focus:border-purple-500" placeholder="••••••••" value={wordpressPassword} onChange={(e) => setWordpressPassword(e.target.value)} />
                      </div>
                      <div className="flex justify-end">
                        <Button
                          onClick={() => handleIntegrationSubmit('wordpress')}
                          className="bg-purple-500 hover:bg-purple-600 text-white font-semibold rounded-md transition-colors flex items-center"
                          disabled={loading}
                        >
                          {loading && activeTab === 'integrations' ? (
                            <FaSpinner className="mr-2 animate-spin" />
                          ) : 'Save WordPress Settings'}
                        </Button>
                        <Button
                          color="gray"
                          className="ml-2"
                          onClick={() => handleTestIntegration('wordpress', getIntegrationId('wordpress'))}
                          disabled={loading}
                        >
                          {loading && activeTab === 'integrations' ? (
                            <FaSpinner className="mr-2 animate-spin" />
                          ) : 'Test Integration'}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>

                 {/* Webhook Integration */}
                 <div className="bg-slate-800/50 border border-slate-700 rounded-lg">
                    <button
                      type="button"
                      className="flex items-center justify-between w-full p-4 text-left text-white"
                      onClick={() => toggleAccordion(2)}
                      aria-controls="accordion-open-body-3"
                      aria-expanded={openAccordion === 2}
                    >
                      <div className="flex items-center">
                        <FaLink className="mr-2 text-xl" />
                        <h5 className="font-semibold text-white">Webhook</h5>
                      </div>
                      {openAccordion === 2 ? <FaChevronUp /> : <FaChevronDown />}
                    </button>
                    <div id="accordion-open-body-3" className={`${openAccordion === 2 ? 'block' : 'hidden'} p-4`} aria-labelledby="accordion-open-heading-3">
                      <p className="mb-2 text-sm text-gray-400">
                        Configure a webhook URL to receive article content in JSON format whenever a new article is generated.
                      </p>
                      <div className="space-y-4">
                        <div>
                          <label htmlFor="webhookUrl" className="block mb-2 text-sm font-medium text-slate-200">Webhook URL</label>
                          <input
                            type="text"
                            id="webhookUrl"
                            className="bg-slate-900/50 border border-slate-700 text-white text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-purple-500 dark:focus:border-purple-500"
                            placeholder="Enter your webhook URL"
                            value={webhookUrl}
                            onChange={(e) => setWebhookUrl(e.target.value)}
                          />
                        </div>
                        <div className="flex justify-end">
                          <Button
                            onClick={() => handleIntegrationSubmit('webhook')}
                            className="bg-purple-500 hover:bg-purple-600 text-white font-semibold rounded-md transition-colors flex items-center"
                            disabled={loading}
                          >
                            {loading && activeTab === 'integrations' ? (
                              <FaSpinner className="mr-2 animate-spin" />
                            ) : 'Save Webhook URL'}
                          </Button>
                          <Button
                            color="gray"
                            className="ml-2"
                            onClick={() => handleTestIntegration('webhook', getIntegrationId('webhook'))}
                            disabled={loading}
                          >
                            {loading && activeTab === 'integrations' ? (
                              <FaSpinner className="mr-2 animate-spin" />
                            ) : 'Test Integration'}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        )}
           {activeTab === 'keywords' && (
              // ... keywords tab content ...
              <div className="space-y-4">
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-2">
        <h3 className="text-lg font-semibold text-white">Keywords</h3>
        <span data-tooltip-id="keywords-info" className="cursor-pointer">
          <FaInfoCircle className="text-gray-400 hover:text-gray-300" size={16} />
        </span>
        <Tooltip
          id="keywords-info"
          place="top"
          effect="solid"
          className="bg-slate-800 text-white px-3 py-2 rounded-md text-sm max-w-[300px]"
        >
          You can view keyword metrics below. Keywords are not editable directly here.
        </Tooltip>
      </div>

      <div className="flex space-x-2">
        {/* Add Keyword Button */}
        <button
            onClick={() => setIsModalOpen(true)}
            className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition flex items-center"
          >
            <FaPlus className="mr-2" />
            <span className="hidden sm:inline">Add Keyword</span> {/* Hidden text on mobile */}
          </button>

          {/* Delete Selected Keywords Button */}
          <button
            onClick={handleDeleteSelectedKeywords}
            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition flex items-center"
          >
            <FaTrash className="mr-2" />
            <span className="hidden sm:inline">Delete Keywords</span> {/* Hidden text on mobile */}
          </button>

      </div>
    </div>

    {loadingKeywords ? (
      <p className="text-slate-400">Loading keywords...</p>
    ) : (
      <div className="overflow-x-auto bg-slate-800 border border-slate-700 rounded-lg">
        <table className="min-w-full table-auto text-sm text-left text-gray-300">
              <thead className="bg-slate-900">
                <tr>
                  <th className="px-4 py-2">
                    {/* Select All Checkbox */}
                    <input
                      type="checkbox"
                      checked={selectedKeywords.length === keywords.length}
                      onChange={() =>
                        setSelectedKeywords(
                          selectedKeywords.length === keywords.length
                            ? [] // Deselect all if all are selected
                            : keywords.map((keyword) => keyword.id) // Select all keywords
                        )
                      }
                    />
                  </th>
                  <th className="px-4 py-2">Keyword</th>
                  <th className="px-4 py-2">Search Volume</th>
                  <th className="px-4 py-2">Difficulty</th>
                  <th className="px-4 py-2">Competition</th>
                  <th className="px-4 py-2">CPC</th>
                  <th className="px-4 py-2">Actions</th>
                </tr>
              </thead>
              <tbody>
              {keywords.length === 0 ? (
    <tr>
    <td colSpan={7} className="py-12">
      <div className="flex flex-col items-center justify-center text-center p-8">
        <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-4">
          <Search className="h-6 w-6 text-muted-foreground" />
        </div>
        <h3 className="text-lg font-medium mb-1">No keywords found</h3>
        <p className="text-muted-foreground mb-6 max-w-sm">
          You haven't added any keywords yet.
        </p>
      </div>
    </td>
  </tr>
) : (
  keywords.map((keyword) => (
    <tr key={keyword.id} className="bg-slate-700 hover:bg-slate-600">
      <td className="px-4 py-2">
        {/* Checkbox for individual keyword */}
        <input
          type="checkbox"
          checked={selectedKeywords.includes(keyword.id)}
          onChange={() => handleSelectKeyword(keyword.id)}
        />
      </td>
      <td className="px-4 py-2">{keyword.keyword}</td>
      <td className="px-4 py-2">{keyword.search_volume_msv || 'N/A'}</td>
      <td className="px-4 py-2">{keyword.keyword_difficulty || 'N/A'}</td>
      <td className="px-4 py-2">
        <span className={getCompetitionColor(keyword.competition)}>
          {keyword.competition || 'N/A'}
        </span>
      </td>
      <td className="px-4 py-2">
        {typeof keyword.cpc === 'number' ? `$${keyword.cpc.toFixed(2)}` : 'N/A'}
      </td>
      <td className="px-4 py-2">
        <Dropdown
          label={<FaEllipsisV className="ml-4 text-gray-400 hover:text-gray-300" size={20} />}
          inline={true}
          className="!p-0"
          arrowIcon={false}
        >
          <Dropdown.Item
            onClick={() => handleDeleteKeyword(keyword.id)}
            className="flex items-center space-x-2 hover:bg-th-dark-300 py-2 px-4 rounded-md"
          >
            <FaTrash className="text-th-gray-400" />
            <span>Delete</span>
          </Dropdown.Item>
        </Dropdown>
      </td>
    </tr>
  ))
)}
              </tbody>
            </table>

      </div>
    )}
  </div>
            )}


                  {/* Add Keyword Modal */}
                  {isModalOpen && (
                     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 !m-0">
                      <div className="bg-slate-900 p-6 rounded-lg shadow-lg w-[90%] sm:w-[400px]">
                        <div className="flex justify-between items-center mb-4">
                          <h3 className="text-lg font-semibold text-white">Add New Keyword</h3>
                          <button onClick={() => setIsModalOpen(false)} className="text-gray-400 hover:text-gray-300">
                            <FaTimes size={20} />
                          </button>
                        </div>
                        <input
                          type="text"
                          value={newKeyword}
                          onChange={(e) => setNewKeyword(e.target.value)}
                          placeholder="Enter keyword..."
                          className="w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
                        />
                        <div className="mt-4 flex justify-end space-x-2">
                          <button
                            onClick={() => setIsModalOpen(false)}
                            className="px-4 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-600 transition"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => handleAddKeyword(newKeyword)}
                            className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition"
                          >
                            Add Keyword
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Edit Keyword Modal (Flowbite) */}
                  <Modal
                        show={showFeedbackModal}
                        onClose={closeFeedbackModal}
                        dismissible
                        className="rounded-xl overflow-hidden shadow-lg"
                      >
                        {/* Modal Header */}
                        <Modal.Header className="flex items-center gap-3 text-xl font-semibold text-white px-6 py-4 bg-gradient-to-r from-blue-500 to-purple-600">
                          <div className='flex'>
                          <FaCommentDots className="text-2xl" />
                          <span>Feedback</span>
                          </div>
                        </Modal.Header>

                        {/* Modal Body */}
                        <Modal.Body className="space-y-5">
                          <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
                            We value your feedback! Let us know how we can improve. We'll review your message and get back to you soon.
                          </p>

                          <div className="grid grid-cols-3 gap-3">
  <button
    onClick={() => handleFeedbackTypeSelect("feature")}
    className={`flex flex-col items-center justify-center p-3 rounded-lg transition-all
                ${feedbackType === "feature"
                  ? "bg-blue-500 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                } w-full focus:outline-none`}
  >
    <FaLightbulb className="text-2xl mb-1" />
    <span className="text-sm font-medium">Feature Request</span>
  </button>

  <button
    onClick={() => handleFeedbackTypeSelect("bug")}
    className={`flex flex-col items-center justify-center p-3 rounded-lg transition-all
                ${feedbackType === "bug"
                  ? "bg-red-500 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                } w-full focus:outline-none`}
  >
    <FaBug className="text-2xl mb-1" />
    <span className="text-sm font-medium">Report Bug</span>
  </button>

  <button
    onClick={() => handleFeedbackTypeSelect("other")}
    className={`flex flex-col items-center justify-center p-3 rounded-lg transition-all
                ${feedbackType === "other"
                  ? "bg-purple-500 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                } w-full focus:outline-none`}
  >
    <FaQuestionCircle className="text-2xl mb-1" />
    <span className="text-sm font-medium">Other</span>
  </button>
</div>

                          {/* Feedback Input */}
                          <Textarea
                            id="message"
                            placeholder="Enter your feedback here..."
                            required
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            rows={4}
                            className="w-full p-3 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-gray-800 dark:text-white resize-none"
                          />
                        </Modal.Body>

                        {/* Modal Footer */}
                        <Modal.Footer className="flex justify-end space-x-3 rounded-b-2xl">
                        <Button
                            color="blue"
                            onClick={handleFeedbackSubmit}
                            className="px-4 py-1 rounded-lg font-medium bg-blue-600 text-white hover:bg-blue-700 transition"
                          >
                            Submit
                          </Button>
                          <Button
                            color="gray"
                            onClick={closeFeedbackModal}
                            className="px-4 py-1 rounded-lg font-medium bg-gray-300 text-gray-800 hover:bg-gray-400 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600 transition"
                          >
                            Cancel
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      {/* Cancel Subscription Confirmation Modal */}
                      <Modal
                        show={isCancelConfirmationOpen}
                        onClose={closeCancelConfirmationModal}
                        dismissible
                        className="rounded-xl overflow-hidden shadow-lg"
                      >
                        <Modal.Header className="text-xl font-semibold text-white px-6 py-4 bg-red-600">
                          Confirm Subscription Cancellation
                        </Modal.Header>
                        <Modal.Body className="space-y-4 px-6 py-5">
                          <p className="text-gray-700 dark:text-gray-300 text-base leading-relaxed">
                            Are you sure you want to cancel your Pro subscription? You will lose access to premium features at the end of your current billing cycle.
                          </p>
                        </Modal.Body>
                        <Modal.Footer className="flex justify-end space-x-3 rounded-b-2xl px-6 py-4">
                          <Button
                            color="gray"
                            onClick={() => handleCancelSubscriptionConfirmation(false)}
                            className="px-4 py-1 rounded-lg font-medium bg-gray-300 text-gray-800 hover:bg-gray-400 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600 transition"
                          >
                            No, Keep Subscription
                          </Button>
                          <Button
                            color="failure"
                            onClick={() => handleCancelSubscriptionConfirmation(true)}
                            className="px-4 py-1 rounded-lg font-medium bg-red-600 text-white hover:bg-red-700 transition"
                          >
                            Yes, Cancel
                          </Button>
                        </Modal.Footer>
                      </Modal>


                    </div>
                    <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

                </div>
              );
            };
      export default Settings;
